const AltTag = {
  AppLogo: 'Pacific Admin',
  Logout: 'Logout',
};

export default AltTag;
